import styled from "styled-components";

import BenesseLogoFooterIcon from "../assets/images/benesse_logo_footer@3x.png";

export const Footer = () => (
  <StyledFooter>
    <a href="https://cat-dog.love/logo" rel="noreferrer" target="_blank">
      <BenesseFooterIconImage src={BenesseLogoFooterIcon} />
    </a>

    <p>
      <a href="https://cat-dog.love/bscg_privacy" rel="noreferrer" target="_blank">個人情報保護法に基づく公表事項等</a> |{" "}
      <a href="https://pet.benesse.ne.jp/info/pet.html" rel="noreferrer" target="_blank">利用者情報の取り扱い</a>
    </p>

    <p>Copyright © Benesse Style Care Group Co.,Ltd. All Rights Reserved.</p>
  </StyledFooter>
);

const StyledFooter = styled.footer`
  font-size: 12px;
  text-align: center;
  background-color: #ffffff;
  min-height: 123px;
`;

const BenesseFooterIconImage = styled.img`
  margin-top: 20px;
  width: 105px;
  height: 25px;
`;
